import { render } from "./chatStoreList.vue?vue&type=template&id=63e7ca1d"
import script from "./chatStoreList.vue?vue&type=script&lang=js"
export * from "./chatStoreList.vue?vue&type=script&lang=js"

import "./chatStoreList.vue?vue&type=style&index=0&id=63e7ca1d&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__